import { render, staticRenderFns } from "./dialogPostInfo.vue?vue&type=template&id=7876dd6e&"
import script from "./dialogPostInfo.vue?vue&type=script&lang=js&"
export * from "./dialogPostInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports